import { endpoints, environment } from "config";
import { GraphQLClient } from "graphql-request";

export function createDatoClient(preview = false): GraphQLClient {
  const endpoint = preview
    ? `https://graphql.datocms.com/preview`
    : `https://graphql.datocms.com/`;

  const isProd = ["production", "uat"].includes(environment);

  const client = new GraphQLClient(endpoint, {
    headers: {
      Authorization: endpoints.datoCmsApiToken || "",
      ...(!isProd && { "X-Environment": "staging" }),
    },
  });

  return client;
}
